import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";

const HelpdeskFilter = ({
    applyFilter,
    listFilterData,
    localstorageKey=''
}) => {
    const filterInputs = {
        status: "",
        use_case_id: [],
        request_id:'',
        pi_no:'',
        ti_no:'',
        date:'',
        requested_name:'',
        approver_l1:'',
        approver_l2:'',
        department_name:'',
        designation_name:''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem(localstorageKey, JSON.stringify(filterFieldsData));
            }}
        >
            <ConstantInput
                label={localization.requestId}
                value={filterFieldsData && filterFieldsData.request_id}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, request_id: val });
                }}
            />

            <ConstantInput
                label={localization.requestName}
                value={filterFieldsData && filterFieldsData.requested_name}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, requested_name: val });
                }}
            />

            <DropDownInput
                label={localization.approverL1}
                data={listFilterData?.l1_dropdown}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        approver_l1: val.id,
                    })
                }
                }
            />

            <DropDownInput
                label={localization.approverL2}
                data={listFilterData?.l2_dropdown}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        approver_l2: val.id,
                    })
                }
                }
            />

            {localstorageKey !== 'help_desk_back_finance_pending' &&
                <DropDownInput
                    label={localization.status}
                    data={listFilterData?.finance_status}
                    getIdValue={(val) =>{
                        setFilterFieldsData({
                            ...filterFieldsData,
                            status: val.id,
                        })
                    }
                    }
                />
            }


            <DropDownInput
                label={localization.useCase}
                data={listFilterData?.use_cases}
                getIdValue={(val) =>{
                    console.log(val)
                    if(val.length > 0 ){
                        setFilterFieldsData({
                            ...filterFieldsData,
                            use_case_id: [val.map((obj) => obj.id)]
                        })
                    }
                }
                }
                multipule={true}
            />

            <ConstantInput
                label={localization.piNo}
                value={filterFieldsData && filterFieldsData.pi_no}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, pi_no: val });
                }}
            />

            <ConstantInput
                label={localization.tiNo}
                value={filterFieldsData && filterFieldsData.ti_no}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, ti_no: val });
                }}
            />

            <ConstantInput
                label={localization.date}
                value={filterFieldsData && filterFieldsData.date}
                type="date"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, date: val });
                }}
            />

            <ConstantInput
                label={'Department'}
                value={filterFieldsData && filterFieldsData.department_name}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, department_name: val });
                }}
            />

            <ConstantInput
                label={'Designation'}
                value={filterFieldsData && filterFieldsData.designation_name}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, designation_name: val });
                }}
            />

            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        localStorage.setItem(localstorageKey, JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem(localstorageKey, JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default HelpdeskFilter;
